import { render, staticRenderFns } from "./TasksReport.vue?vue&type=template&id=3a48c82c&scoped=true&"
import script from "./TasksReport.vue?vue&type=script&lang=js&"
export * from "./TasksReport.vue?vue&type=script&lang=js&"
import style0 from "./TasksReport.vue?vue&type=style&index=0&id=3a48c82c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a48c82c",
  null
  
)

export default component.exports